import { create } from 'zustand';
import i18n from 'i18n';
import { AccountsApi, RemindPinRequest, RestApiError, StatusCodeEnum } from '@shared/api';

interface UseRemindPinStore {
  loading: boolean;
  data: boolean | null;
  error: string | null;
  remind: (request: RemindPinRequest) => Promise<void>;
  clear: () => void;
}

export const useRemindPinStore = create<UseRemindPinStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  remind: async (request: RemindPinRequest) => {
    try {
      set({ loading: true, data: null, error: null });
      await AccountsApi.remindPin(request);
      set({ loading: false, data: true });
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Wrong password';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_BAD_REQUEST:
          if (Array.isArray(restError?.data)) errorMessage = restError?.data?.join('\n');
          break;
      }

      set({ loading: false, data: false, error: i18n.t(`errors.api.${errorMessage}`, errorMessage) });
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
